// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ITVa","toggleWrap":"styles_toggleWrap__34OmS","content":"styles_content__3Cn7n","selectAreaCode":"styles_selectAreaCode__1nwwc"};